import { SUPPORTED_FONTS } from 'prose-core'
import { ReactComponent as AlegreyaImg } from 'assets/img/fonts/alegreya.svg'
import { ReactComponent as AlegreyaSansImg } from 'assets/img/fonts/alegreyaSans.svg'
import { ReactComponent as AndadaProImg } from 'assets/img/fonts/andadaPro.svg'
import { ReactComponent as AntonImg } from 'assets/img/fonts/anton.svg'
import { ReactComponent as ArchivoImg } from 'assets/img/fonts/archivo.svg'
import { ReactComponent as ArchivoNarrowImg } from 'assets/img/fonts/archivoNarrow.svg'
import { ReactComponent as ArialImg } from 'assets/img/fonts/arial.svg'
import { ReactComponent as ArialBlackImg } from 'assets/img/fonts/arialBlack.svg'
import { ReactComponent as ArvoImg } from 'assets/img/fonts/arvo.svg'
import { ReactComponent as BarlowImg } from 'assets/img/fonts/barlow.svg'
import { ReactComponent as BioRhymeImg } from 'assets/img/fonts/biorhyme.svg'
import { ReactComponent as CabinImg } from 'assets/img/fonts/cabin.svg'
import { ReactComponent as CardoImg } from 'assets/img/fonts/cardo.svg'
import { ReactComponent as CatamaranImg } from 'assets/img/fonts/catamaran.svg'
import { ReactComponent as CaveatImg } from 'assets/img/fonts/caveat.svg'
import { ReactComponent as ChivoImg } from 'assets/img/fonts/chivo.svg'
import { ReactComponent as ComicSansImg } from 'assets/img/fonts/comicSans.svg'
import { ReactComponent as ConcertOneImg } from 'assets/img/fonts/concertOne.svg'
import { ReactComponent as CormorantImg } from 'assets/img/fonts/cormorant.svg'
import { ReactComponent as CourierNewImg } from 'assets/img/fonts/courierNew.svg'
import { ReactComponent as CrimsonProImg } from 'assets/img/fonts/crimsonPro.svg'
import { ReactComponent as DancingScriptImg } from 'assets/img/fonts/dancingScript.svg'
import { ReactComponent as DmSansImg } from 'assets/img/fonts/dmSans.svg'
import { ReactComponent as DomineImg } from 'assets/img/fonts/domine.svg'
import { ReactComponent as DosisImg } from 'assets/img/fonts/dosis.svg'
import { ReactComponent as EbGaramondImg } from 'assets/img/fonts/ebGaramond.svg'
import { ReactComponent as EczarImg } from 'assets/img/fonts/eczar.svg'
import { ReactComponent as EncodeSansImg } from 'assets/img/fonts/encodeSans.svg'
import { ReactComponent as EnriquetaImg } from 'assets/img/fonts/enriqueta.svg'
import { ReactComponent as EpilogueImg } from 'assets/img/fonts/epilogue.svg'
import { ReactComponent as FiraSansImg } from 'assets/img/fonts/firaSans.svg'
import { ReactComponent as GeorgiaImg } from 'assets/img/fonts/georgia.svg'
import { ReactComponent as HahmletImg } from 'assets/img/fonts/hahmlet.svg'
import { ReactComponent as HelveticaNeueImg } from 'assets/img/fonts/helveticaNeue.svg'
import { ReactComponent as IbmPlexMonoImg } from 'assets/img/fonts/ibmPlexMono.svg'
import { ReactComponent as IbmPlexSansImg } from 'assets/img/fonts/ibmPlexSans.svg'
import { ReactComponent as IbmPlexSerifImg } from 'assets/img/fonts/ibmPlexSerif.svg'
import { ReactComponent as ImpactImg } from 'assets/img/fonts/impact.svg'
import { ReactComponent as InconsolataImg } from 'assets/img/fonts/inconsolata.svg'
import { ReactComponent as InknutAntiquaImg } from 'assets/img/fonts/inknutAntiqua.svg'
import { ReactComponent as InriaSerifImg } from 'assets/img/fonts/inriaSerif.svg'
import { ReactComponent as InterImg } from 'assets/img/fonts/inter.svg'
import { ReactComponent as JetBrainsMonoImg } from 'assets/img/fonts/jetBrainsMono.svg'
import { ReactComponent as JosefinSansImg } from 'assets/img/fonts/josefinSans.svg'
import { ReactComponent as JostImg } from 'assets/img/fonts/jost.svg'
import { ReactComponent as KarlaImg } from 'assets/img/fonts/karla.svg'
import { ReactComponent as LatoImg } from 'assets/img/fonts/lato.svg'
import { ReactComponent as LibreBaskervilleImg } from 'assets/img/fonts/libreBaskerville.svg'
import { ReactComponent as LibreFranklinImg } from 'assets/img/fonts/libreFranklin.svg'
import { ReactComponent as LobsterTwoImg } from 'assets/img/fonts/lobsterTwo.svg'
import { ReactComponent as LoraImg } from 'assets/img/fonts/lora.svg'
import { ReactComponent as ManropeImg } from 'assets/img/fonts/manrope.svg'
import { ReactComponent as MavenProImg } from 'assets/img/fonts/mavenPro.svg'
import { ReactComponent as MerriweatherImg } from 'assets/img/fonts/merriweather.svg'
import { ReactComponent as MontserratImg } from 'assets/img/fonts/montserrat.svg'
import { ReactComponent as MuktaImg } from 'assets/img/fonts/mukta.svg'
import { ReactComponent as NeutonImg } from 'assets/img/fonts/neuton.svg'
import { ReactComponent as NewsreaderImg } from 'assets/img/fonts/newsreader.svg'
import { ReactComponent as NotoSansImg } from 'assets/img/fonts/notoSans.svg'
import { ReactComponent as NunitoImg } from 'assets/img/fonts/nunito.svg'
import { ReactComponent as NunitoSansImg } from 'assets/img/fonts/nunitoSans.svg'
import { ReactComponent as OldStandardTtImg } from 'assets/img/fonts/oldStandardTt.svg'
import { ReactComponent as OpenSansImg } from 'assets/img/fonts/openSans.svg'
import { ReactComponent as OswaldImg } from 'assets/img/fonts/oswald.svg'
import { ReactComponent as OxygenImg } from 'assets/img/fonts/oxygen.svg'
import { ReactComponent as PacificoImg } from 'assets/img/fonts/pacifico.svg'
import { ReactComponent as PermanentMarkerImg } from 'assets/img/fonts/permanentMarker.svg'
import { ReactComponent as PlayImg } from 'assets/img/fonts/play.svg'
import { ReactComponent as PlayfairDisplayImg } from 'assets/img/fonts/playfairDisplay.svg'
import { ReactComponent as PoppinsImg } from 'assets/img/fonts/poppins.svg'
import { ReactComponent as PromptImg } from 'assets/img/fonts/prompt.svg'
import { ReactComponent as ProzaLibreImg } from 'assets/img/fonts/prozaLibre.svg'
import { ReactComponent as PtSansImg } from 'assets/img/fonts/ptSans.svg'
import { ReactComponent as PtSerifImg } from 'assets/img/fonts/ptSerif.svg'
import { ReactComponent as QuicksandImg } from 'assets/img/fonts/quicksand.svg'
import { ReactComponent as RalewayImg } from 'assets/img/fonts/raleway.svg'
import { ReactComponent as RecursiveImg } from 'assets/img/fonts/recursive.svg'
import { ReactComponent as RobotoImg } from 'assets/img/fonts/roboto.svg'
import { ReactComponent as RobotoCondensedImg } from 'assets/img/fonts/robotoCondensed.svg'
import { ReactComponent as RobotoMonoImg } from 'assets/img/fonts/robotoMono.svg'
import { ReactComponent as RobotoSlabImg } from 'assets/img/fonts/robotoSlab.svg'
import { ReactComponent as RosarioImg } from 'assets/img/fonts/rosario.svg'
import { ReactComponent as RosarivoImg } from 'assets/img/fonts/rosarivo.svg'
import { ReactComponent as RubikImg } from 'assets/img/fonts/rubik.svg'
import { ReactComponent as SairaCondensedImg } from 'assets/img/fonts/sairaCondensed.svg'
import { ReactComponent as SignikaImg } from 'assets/img/fonts/signika.svg'
import { ReactComponent as SoraImg } from 'assets/img/fonts/sora.svg'
import { ReactComponent as SourceCodeProImg } from 'assets/img/fonts/sourceCodePro.svg'
import { ReactComponent as SourceSansImg } from 'assets/img/fonts/sourceSans.svg'
import { ReactComponent as SourceSerifImg } from 'assets/img/fonts/sourceSerif.svg'
import { ReactComponent as SpaceGroteskImg } from 'assets/img/fonts/spaceGrotesk.svg'
import { ReactComponent as SpaceMonoImg } from 'assets/img/fonts/spaceMono.svg'
import { ReactComponent as SpectralImg } from 'assets/img/fonts/spectral.svg'
import { ReactComponent as SyneImg } from 'assets/img/fonts/syne.svg'
import { ReactComponent as TimesNewRomanImg } from 'assets/img/fonts/timesNewRoman.svg'
import { ReactComponent as TitilliumWebImg } from 'assets/img/fonts/titilliumWeb.svg'
import { ReactComponent as TrebuchetImg } from 'assets/img/fonts/trebuchetMs.svg'
import { ReactComponent as UbuntuImg } from 'assets/img/fonts/ubuntu.svg'
import { ReactComponent as UbuntuMonoImg } from 'assets/img/fonts/ubuntuMono.svg'
import { ReactComponent as VerdanaImg } from 'assets/img/fonts/verdana.svg'
import { ReactComponent as VollkornImg } from 'assets/img/fonts/vollkorn.svg'
import { ReactComponent as WorkSansImg } from 'assets/img/fonts/workSans.svg'

export type FontFamilyType = (typeof SUPPORTED_FONTS)[number]

export const getFontSvg = (fontFamily: FontFamilyType) => {
  switch (fontFamily) {
    case 'Alegreya':
      return <AlegreyaImg aria-label="Alegreya" />
    case 'Alegreya Sans':
      return <AlegreyaSansImg aria-label="Alegreya Sans" />
    case 'Andada Pro':
      return <AndadaProImg aria-label="Andada Pro" />
    case 'Anton':
      return <AntonImg aria-label="Anton" />
    case 'Archivo':
      return <ArchivoImg aria-label="Archivo" />
    case 'Archivo Narrow':
      return <ArchivoNarrowImg aria-label="Archivo Narrow" />
    case 'Arial':
      return <ArialImg aria-label="Arial" />
    case 'Arial Black':
      return <ArialBlackImg aria-label="Arial Black" />
    case 'Arvo':
      return <ArvoImg aria-label="Arvo" />
    case 'Barlow':
      return <BarlowImg aria-label="Barlow" />
    case 'BioRhyme':
      return <BioRhymeImg aria-label="BioRhyme" />
    case 'Cabin':
      return <CabinImg aria-label="Cabin" />
    case 'Cardo':
      return <CardoImg aria-label="Cardo" />
    case 'Catamaran':
      return <CatamaranImg aria-label="Catamaran" />
    case 'Caveat':
      return <CaveatImg aria-label="Caveat" />
    case 'Chivo':
      return <ChivoImg aria-label="Chivo" />
    case 'Comic Sans MS':
      return <ComicSansImg aria-label="Comic Sans" />
    case 'Concert One':
      return <ConcertOneImg aria-label="ConcertOne" />
    case 'Cormorant':
      return <CormorantImg aria-label="Cormorant" />
    case 'Courier New':
      return <CourierNewImg aria-label="Courier New" />
    case 'Crimson Pro':
      return <CrimsonProImg aria-label="Crimson Pro" />
    case 'Dancing Script':
      return <DancingScriptImg aria-label="Dancing Script" />
    case 'DM Sans':
      return <DmSansImg aria-label="DM Sans" />
    case 'Domine':
      return <DomineImg aria-label="Domine" />
    case 'Dosis':
      return <DosisImg aria-label="Dosis" />
    case 'EB Garamond':
      return <EbGaramondImg aria-label="EB Garamond" />
    case 'Eczar':
      return <EczarImg aria-label="Eczar" />
    case 'Encode Sans':
      return <EncodeSansImg aria-label="Encode Sans" />
    case 'Enriqueta':
      return <EnriquetaImg aria-label="Enriqueta" />
    case 'Epilogue':
      return <EpilogueImg aria-label="Epilogue" />
    case 'Fira Sans':
      return <FiraSansImg aria-label="Fira Sans" />
    case 'Georgia':
      return <GeorgiaImg aria-label="Georgia" />
    case 'Hahmlet':
      return <HahmletImg aria-label="Hahmlet" />
    case 'Helvetica Neue':
      return <HelveticaNeueImg aria-label="Helvetica Neue" />
    case 'IBM Plex Mono':
      return <IbmPlexMonoImg aria-label="IBM Plex Mono" />
    case 'IBM Plex Sans':
      return <IbmPlexSansImg aria-label="IBM Plex Sans" />
    case 'IBM Plex Serif':
      return <IbmPlexSerifImg aria-label="IBM Plex Serif" />
    case 'Impact':
      return <ImpactImg aria-label="Impact" />
    case 'Inconsolata':
      return <InconsolataImg aria-label="Inconsolata" />
    case 'Inknut Antiqua':
      return <InknutAntiquaImg aria-label="Inknut Antiqua" />
    case 'Inria Serif':
      return <InriaSerifImg aria-label="Inria Serif" />
    case 'Inter':
      return <InterImg aria-label="Inter" />
    case 'JetBrains Mono':
      return <JetBrainsMonoImg aria-label="JetBrains Mono" />
    case 'Josefin Sans':
      return <JosefinSansImg aria-label="Josefin Sans" />
    case 'Jost':
      return <JostImg aria-label="Jost" />
    case 'Karla':
      return <KarlaImg aria-label="Karla" />
    case 'Lato':
      return <LatoImg aria-label="Lato" />
    case 'Libre Baskerville':
      return <LibreBaskervilleImg aria-label="Libre Baskerville" />
    case 'Libre Franklin':
      return <LibreFranklinImg aria-label="Libre Franklin" />
    case 'Lobster Two':
      return <LobsterTwoImg aria-label="Lobster Two" />
    case 'Lora':
      return <LoraImg aria-label="Lora" />
    case 'Manrope':
      return <ManropeImg aria-label="Manrope" />
    case 'Maven Pro':
      return <MavenProImg aria-label="Maven Pro" />
    case 'Merriweather':
      return <MerriweatherImg aria-label="Merriweather" />
    case 'Montserrat':
      return <MontserratImg aria-label="Montserrat" />
    case 'Mukta':
      return <MuktaImg aria-label="Mukta" />
    case 'Neuton':
      return <NeutonImg aria-label="Neuton" />
    case 'Newsreader':
      return <NewsreaderImg aria-label="Newsreader" />
    case 'Noto Sans':
      return <NotoSansImg aria-label="Noto Sans" />
    case 'Nunito':
      return <NunitoImg aria-label="Nunito" />
    case 'Nunito Sans':
      return <NunitoSansImg aria-label="Nunito Sans" />
    case 'Old Standard TT':
      return <OldStandardTtImg aria-label="Old Standard TT" />
    case 'Open Sans':
      return <OpenSansImg aria-label="Open Sans" />
    case 'Oswald':
      return <OswaldImg aria-label="Oswald" />
    case 'Oxygen':
      return <OxygenImg aria-label="Oxygen" />
    case 'Pacifico':
      return <PacificoImg aria-label="Pacifico" />
    case 'Permanent Marker':
      return <PermanentMarkerImg aria-label="Permanent Marker" />
    case 'Play':
      return <PlayImg aria-label="Play" />
    case 'Playfair Display':
      return <PlayfairDisplayImg aria-label="Playfair Display" />
    case 'Poppins':
      return <PoppinsImg aria-label="Poppins" />
    case 'Prompt':
      return <PromptImg aria-label="Prompt" />
    case 'Proza Libre':
      return <ProzaLibreImg aria-label="Proza Libre" />
    case 'PT Sans':
      return <PtSansImg aria-label="PT Sans" />
    case 'PT Serif':
      return <PtSerifImg aria-label="PT Serif" />
    case 'Quicksand':
      return <QuicksandImg aria-label="Quicksand" />
    case 'Raleway':
      return <RalewayImg aria-label="Raleway" />
    case 'Recursive':
      return <RecursiveImg aria-label="Recursive" />
    case 'Roboto':
      return <RobotoImg aria-label="Roboto" />
    case 'Roboto Condensed':
      return <RobotoCondensedImg aria-label="Roboto Condensed" />
    case 'Roboto Mono':
      return <RobotoMonoImg aria-label="Roboto Mono" />
    case 'Roboto Slab':
      return <RobotoSlabImg aria-label="Roboto Slab" />
    case 'Rosario':
      return <RosarioImg aria-label="Rosario" />
    case 'Rosarivo':
      return <RosarivoImg aria-label="Rosarivo" />
    case 'Rubik':
      return <RubikImg aria-label="Rubik" />
    case 'Saira Condensed':
      return <SairaCondensedImg aria-label="Saira Condensed" />
    case 'Signika':
      return <SignikaImg aria-label="Signika" />
    case 'Sora':
      return <SoraImg aria-label="Sora" />
    case 'Source Code Pro':
      return <SourceCodeProImg aria-label="Source Code Pro" />
    case 'Source Sans Pro':
      return <SourceSansImg aria-label="Source Sans Pro" />
    case 'Source Serif Pro':
      return <SourceSerifImg aria-label="Source Serif Pro" />
    case 'Space Grotesk':
      return <SpaceGroteskImg aria-label="Space Grotesk" />
    case 'Space Mono':
      return <SpaceMonoImg aria-label="Space Mono" />
    case 'Spectral':
      return <SpectralImg aria-label="Spectral" />
    case 'Syne':
      return <SyneImg aria-label="Syne" />
    case 'Times New Roman':
      return <TimesNewRomanImg aria-label="Times New Roman" />
    case 'Titillium Web':
      return <TitilliumWebImg aria-label="Titillium Web" />
    case 'Trebuchet MS':
      return <TrebuchetImg aria-label="Trebuchet MS" />
    case 'Ubuntu':
      return <UbuntuImg aria-label="Ubuntu" />
    case 'Ubuntu Mono':
      return <UbuntuMonoImg aria-label="Ubuntu Mono" />
    case 'Verdana':
      return <VerdanaImg aria-label="Verdana" />
    case 'Vollkorn':
      return <VollkornImg aria-label="Vollkorn" />
    case 'Work Sans':
      return <WorkSansImg aria-label="Work Sans" />
  }
}

export const fontFamilyValidator = (fontFamily: string): boolean => {
  return SUPPORTED_FONTS.includes(fontFamily as any)
}
